import useGeoMX from './geoMX';

export default useGeoMX;
